import React, { useState, useEffect } from 'react';
import Achievements from '../components/globals/Achievements';
import points from '../assets/images/badge-9491.png';
import coins from '../assets/images/badge-9488.png';
import badge from '../assets/images/badge-9489.png';
import badge5 from '../assets/images/badge-9490.png';
import coin from '../assets/images/coin.png';
import ai from '../assets/images/ai.png';
import coinImage from '../assets/images/coin-image.png';
import fire from '../assets/images/fire.png';
import analytics from '../assets/images/analytics.png';
import QuestionItem from '../components/globals/QuestionItem';
import profileimage from '../assets/images/profile-image.png';
import CustomPrimaryButton from '../components/globals/CustomPrimaryButton';
import { useLocation, useNavigate } from 'react-router-dom';
import CustomModal from '../components/globals/CustomModal';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { userAtom } from "../store/authAtom";
import { getProfileAPI } from '../services/authAPI';
import { BASE_IMG_URL, ENDPOINTS } from '../utils/EndPoint';
import { apiGetAuth } from '../utils/Api';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { isLoaderState } from '../store/RecoilStore';
import CustomSecondaryButton from '../components/globals/CustomSecondaryButton';
import { GrHelpBook } from "react-icons/gr";

function Profile() {
  const navigate = useNavigate();
  const location = useLocation();
  const [showModal, setShowModal] = useState(false);
  const [user, setUser] = useRecoilState(userAtom);
  const [badges, setBadges] = useState([]);
  const [profile, setProfile] = useState(null);
  const [userprofile, setUserProfile] = useState(null);
  const [oceans, setOceans] = useState([]);
  const [isLoaderInfo, setIsLoaderInfo] = useRecoilState(isLoaderState);
  const [showGuestModal, setGuestModal] = useState(false);
  // const [modal, setModal] = useRecoilState(modalState);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 3 },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 480,
        settings: { slidesToShow: 1 },
      },
    ],
  };

  const getOceans = async () => {
    setIsLoaderInfo(true)
    apiGetAuth(
      ENDPOINTS.GetOceans,
      (res) => {
        setOceans(res)
        setIsLoaderInfo(false)
      },
      (err) => {
        console.log("err", err)
        setIsLoaderInfo(false)
      }
    );
  }

  const getProfile = async (userId) => {
    setIsLoaderInfo(true);
    apiGetAuth(
      `${ENDPOINTS.GetProfile}/${userId}`,
      (res) => {
        console.log("Profile data:", res);
        setUserProfile(res || {});
        setIsLoaderInfo(false);
      },
      (err) => {
        console.log("Error fetching profile", err);
        setIsLoaderInfo(false);
      }
    );
  };

  useEffect(() => {
    if (oceans) {
      setGuestModal(true);
    }
  }, [oceans]);

  const getBadges = async () => {
    apiGetAuth(
      `${ENDPOINTS.GetBadges}`,
      (res) => {
        setBadges(res);
      },
      (err) => {
        console.log("Error fetching badges", err);
      }
    );
  };

  useEffect(() => {
    getBadges();
    getOceans();
    getProfileAPI(user.id).then((res) => {
      setProfile(res.data);
    }).catch((err) => {
      console.log("Error fetching profile", err);
    });
    getProfile(user.id);
  }, [user]);

  const handleButtonClick = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const steps = [
    "/admin/ocean",
    "/admin/challenge",
    "/admin/quest",
    "/admin/wallet",
  ];

  // useEffect(() => {
  //   if (steps.includes(location.pathname)) {
  //     setModal((prev) => ({ ...prev, isOpen: true }));
  //   }
  // }, [location.pathname, setModal]);

  // const handleNext = () => {
  //   if (modal.step < steps.length) {
  //     setModal({ ...modal, step: modal.step + 1 });
  //     navigate(steps[modal.step]);
  //   } else {
  //     setModal({ isOpen: false, step: 1 });
  //     navigate("/dashboard");
  //   }
  // };

  // const handleBack = () => {
  //   if (modal.step > 1) {
  //     setModal({ ...modal, step: modal.step - 1 });
  //     navigate(steps[modal.step - 2]);
  //   }
  // };
  function getDayOfWeek(dateString) {
    const date = new Date(dateString);

    // Array of day names
    const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

    // Get the day of the week (0-6)
    const dayIndex = date.getDay();

    // Return the day name (e.g., "Monday")
    return daysOfWeek[dayIndex];
  }

  return (
    <div className='achievement'>
      <div className='container pb-4'>

        <div className='row pt-4'>
          <div className='d-flex justify-content-end align-items-center'>
            {/* <div className='p-2 bg-light rounded' onClick={handleButtonClick}>
              <GrHelpBook size={40} color='#00204E' />
            </div> */}
            <CustomPrimaryButton
              btnTextPro="Edit Profile"
              classNamePro="btn-custom-achievement"
              customWelcomeClass="btn-achievement-custom-box"
              handleOnClick={() => navigate("/admin/edit-profile")}
            />
          </div>

        </div>

        <div className="container text-center">
          <div className="profile pt-5 d-inline-block">
            <div className="profile-image-container d-inline-block">
              <img
                src={user?.profile_picture ? `${process.env.REACT_APP_BASE_URL}/${user.profile_picture.media_path}` : profileimage}
                className="profile-image"
                alt="Profile"
              />
            </div>
            <div className="text-white">
              <h2 className="skranji-regular mt-4">{user?.name}</h2>
              <p className="mt-2">{user?.email}</p>
            </div>
          </div>
        </div>

        <h2 className='pt-4 text-white skranji-regular'>Statistics</h2>
        <div className='row mb-4'>
          <div className='col-lg-3'>
            <Achievements
              achievementImage={coinImage}
              achievementPara="Coins"
              achievementTitle={user?.total_coins}
            />
          </div>
          <div className='col-lg-3'>
            <Achievements
              achievementImage={fire}
              achievementPara="Day Streaks"
              achievementTitle={userprofile?.daily_streak_count || 0}
            />
          </div>
        </div>
        <div className='d-flex justify-content-between'>
          <h2 className='pt-4 text-white skranji-regular'>Badges</h2>
          <h2 className='pt-4 text-white skranji-regular cursor-pointer' onClick={() => navigate("/admin/all-badges")}>View All</h2>
        </div>

        <Slider {...settings}>
          {badges.map((badge, index) => (
            <div key={index} className="mb-2">
              <Achievements
                achievementImage={BASE_IMG_URL + '/' + (badge.user_badge ? badge.avatar : badge.avatar_lock)}
                achievementTitle={badge.goal_name}
                isSpecial={!badge.user_badge}
              />
            </div>
          ))}
        </Slider>

        <h2 className='pt-4 text-white skranji-regular'>Progress</h2>

        <div className='row mb-4'>

          {oceans && oceans.length > 0 ? (
            oceans.map((item, ind) => (
              <div className='col-lg-4 mb-3'>
                <QuestionItem
                  key={ind}
                  welcomeicon={`${process.env.REACT_APP_BASE_URL}/${item.image}`}
                  text={item.name}
                  progressBar={{ now: item.completion_percentage.percentage }}
                  customTime={getDayOfWeek(item.updated_at)}
                />
              </div>
            ))
          ) : (
            <div>
              <p>No Ocean</p>
            </div>
          )}
        </div>

      </div>

      {/* <CustomModal
        size="sm"
        showModal={modal.isOpen}
        hideModal={() => setModal({ isOpen: false, step: 1 })}
        title={`Step ${modal.step}`}
      >
        <div className="text-center">
          {modal.step === 1 && <h5 className="text-white mb-5">Step 1: Ocean Guide</h5>}
          {modal.step === 2 && <h5 className="text-white mb-5">Step 2: Challenge Overview</h5>}
          {modal.step === 3 && <h5 className="text-white mb-5">Step 3: Quest Details</h5>}
          {modal.step === 4 && <h5 className="text-white mb-5">Step 4: Wallet Information</h5>}

          <div className="d-flex justify-content-between">
            {modal.step > 1 && (
              <button className="btn btn-secondary" onClick={handleBack}>
                Back
              </button>
            )}
            <button className="btn btn-primary" onClick={handleNext}>
              {modal.step < steps.length ? "Next" : "Finish"}
            </button>
          </div>
        </div>
      </CustomModal> */}

      <CustomModal
        isSpecial={true}
        size='lg'
        progressBar={{ now: 50 }}
        hideModal={() => setShowModal(false)}
        showModal={showModal}
        title="Select Ocean"
        onClose={handleCloseModal}
      >
        <div className='ocean-modal text-center'>
          <img src={coins} className='modal-image-profile mb-4' alt="Coins" />
          <h2 className='text-white mb-5'>Business Master</h2>
          <h2 className='text-white mt-2 mb-5'>Finish Business Master Challenge to unlock this achievement</h2>
        </div>
      </CustomModal>

      <CustomModal
        isSpecial={true}
        size='lg'
        progressBar={{ now: 50 }}
        hideModal={() => setShowModal(false)}
        showModal={showModal}
        title="Select Ocean"
        onClose={handleCloseModal}
      >
        <div className='guide-modal text-center'>
          <img src={coins} className='modal-image-profile mb-4' alt="Coins" />
          <h2 className='text-white mb-5'>Business Master</h2>
          <h2 className='text-white mt-2 mb-5'>Finish Business Master Challenge to unlock this achievement</h2>
        </div>
      </CustomModal>

      {user?.type === "guest_user" && (
        <CustomModal
          size="md"
          hideModal={() => navigate("/admin/ocean")}
          showModal={showGuestModal}
          title="Select Ocean"
        >
          <div className="ocean-modal text-center">
            <h2 className='text-white font-24 text-bold skranji-regular'>This feature is not available for guest users</h2>
            <div class="buttons d-flex justify-content-center">
              <CustomSecondaryButton
                btnTextPro="Cancel"
                classNamePro="btn btn-seondary"
                handleOnClick={() => navigate("/admin/ocean")}
              />
              <CustomPrimaryButton
                btnTextPro="Sign Up"
                classNamePro="btn btn-primary mt-2"
                handleOnClick={() => {
                  navigate("/register-form");
                }}
              />
            </div>
          </div>
        </CustomModal>
      )}

    </div>
  );
}

export default Profile;
